import ParticipatedFormsPage from '@/views/covers/ParticipatedFormsPage'

export default function ParticipatedFormsScreen() {
  return <ParticipatedFormsPage />
}
